import { useState } from "react";
import { SESSION_STORAGE_KEYS } from "../constants";

export const useLastProductListingPath = () => {
  const [href] = useState(() => {
    if (typeof window !== "undefined") {
      const lastPLPState = sessionStorage.getItem(
        SESSION_STORAGE_KEYS.LAST_PLP_STATE
      );
      if (lastPLPState?.startsWith("/products?")) {
        return lastPLPState;
      }
    }
    return "/products";
  });
  return href;
};
